import {
  CREATE_INVOICE_CYCLES,
  CREATE_INVOICE_CYCLES_FAIL,
  CREATE_INVOICE_CYCLES_SUCCESS,
  CREATE_REPORT_INVOICE,
  CREATE_REPORT_INVOICE_FAIL,
  CREATE_REPORT_INVOICE_SUCCESS,
  DOWNLOAD_REPORT_INVOICE,
  DOWNLOAD_REPORT_INVOICE_FAIL,
  DOWNLOAD_REPORT_INVOICE_SUCCESS,
  EXECUTE_REPORT,
  EXECUTE_REPORT_FAIL,
  EXECUTE_REPORT_SUCCESS,
  GET_REPORT_INVOICE_PROGRESS,
  GET_REPORT_INVOICE_PROGRESS_FAIL,
  GET_REPORT_INVOICE_PROGRESS_SUCCESS,
  LIST_INVOICE_TO_SUMMARY,
  LIST_INVOICE_TO_SUMMARY_FAIL,
  LIST_INVOICE_TO_SUMMARY_SUCCESS,
  LIST_KHDD_INVOICE_TO_SUMMARY,
  LIST_KHDD_INVOICE_TO_SUMMARY_FAIL,
  LIST_KHDD_INVOICE_TO_SUMMARY_SUCCESS,
  RELEASE_INVOICE_CYCLES,
  RELEASE_INVOICE_CYCLES_FAIL,
  RELEASE_INVOICE_CYCLES_SUCCESS,
  REPORT_INVOICE_LIST,
  REPORT_INVOICE_LIST_FAIL,
  REPORT_INVOICE_LIST_RESET,
  REPORT_INVOICE_LIST_SUCCESS,
  RESET_CREATE_INVOICE_CYCLES,
  RESET_CREATE_REPORT_INVOICE,
  RESET_DOWNLOAD_REPORT_INVOICE,
  RESET_EXECUTE_REPORT,
  RESET_GET_REPORT_INVOICE_PROGRESS,
  RESET_LIST_INVOICE_TO_SUMMARY,
  RESET_LIST_KHDD_INVOICE_TO_SUMMARY,
  RESET_RELEASE_INVOICE_CYCLES,
  RESET_TRANSFER_USB_INVOICE_CYCLES,
  SET_COLUMN_VISIBLE_REPORT_INVOICE_LIST,
  SET_COLUMN_VISIBLE_SUMMARY_INVOICE_LIST,
  SUMMARY_INVOICE_LIST,
  SUMMARY_INVOICE_LIST_FAIL,
  SUMMARY_INVOICE_LIST_SUCCESS,
  TRANSFER_USB_INVOICE_CYCLES,
  TRANSFER_USB_INVOICE_CYCLES_FAIL,
  TRANSFER_USB_INVOICE_CYCLES_SUCCESS,
} from "./actionTypes";

// Danh sách bảng thống kê
export const getSummaryInvoiceList = params => ({
  type: SUMMARY_INVOICE_LIST,
  params,
});

export const getSummaryInvoiceListSuccess = (listData, totalCount) => ({
  type: SUMMARY_INVOICE_LIST_SUCCESS,
  listData,
  totalCount,
});

export const getSummaryInvoiceListFail = error => ({
  type: SUMMARY_INVOICE_LIST_FAIL,
  error,
});

export const resetSummaryInvoiceList = error => ({
  type: SUMMARY_INVOICE_LIST,
});

export const setColumnVisibleSummaryInvoiceList = (field, value) => ({
  type: SET_COLUMN_VISIBLE_SUMMARY_INVOICE_LIST,
  field,
  value,
});

// Phát hànhh
export const releaseInvoiceCycles = id => ({
  type: RELEASE_INVOICE_CYCLES,
  id,
});

export const releaseInvoiceCyclesSuccess = () => ({
  type: RELEASE_INVOICE_CYCLES_SUCCESS,
});

export const releaseInvoiceCyclesFail = error => ({
  type: RELEASE_INVOICE_CYCLES_FAIL,
  error,
});
export const resetReleaseInvoiceCycles = () => ({
  type: RESET_RELEASE_INVOICE_CYCLES,
});

// listInvoiceToSummary
export const listInvoiceToSummary = (params, khmshdon) => ({
  type: LIST_INVOICE_TO_SUMMARY,
  params,
  khmshdon,
});

export const listInvoiceToSummarySuccess = data => ({
  type: LIST_INVOICE_TO_SUMMARY_SUCCESS,
  data,
});

export const listInvoiceToSummaryFail = error => ({
  type: LIST_INVOICE_TO_SUMMARY_FAIL,
  error,
});
export const resetListInvoiceToSummary = () => ({
  type: RESET_LIST_INVOICE_TO_SUMMARY,
});

// listKhddInvoiceToSummary
export const listKhddInvoiceToSummary = id => ({
  type: LIST_KHDD_INVOICE_TO_SUMMARY,
  id,
});

export const listKhddInvoiceToSummarySuccess = data => ({
  type: LIST_KHDD_INVOICE_TO_SUMMARY_SUCCESS,
  data,
});

export const listKhddInvoiceToSummaryFail = error => ({
  type: LIST_KHDD_INVOICE_TO_SUMMARY_FAIL,
  error,
});
export const resetListKhddInvoiceToSummary = () => ({
  type: RESET_LIST_KHDD_INVOICE_TO_SUMMARY,
});

// Create
export const createInvoiceCycles = data => ({
  type: CREATE_INVOICE_CYCLES,
  data,
});

export const createInvoiceCyclesSuccess = () => ({
  type: CREATE_INVOICE_CYCLES_SUCCESS,
});

export const createInvoiceCyclesFail = error => ({
  type: CREATE_INVOICE_CYCLES_FAIL,
  error,
});
export const resetCreateInvoiceCycles = () => ({
  type: RESET_CREATE_INVOICE_CYCLES,
});

// transferUsbInvoiceCycles
export const transferUsbInvoiceCycles = (id, typeSend, content) => ({
  type: TRANSFER_USB_INVOICE_CYCLES,
  id,
  typeSend,
  content,
});

export const transferUsbInvoiceCyclesSuccess = data => ({
  type: TRANSFER_USB_INVOICE_CYCLES_SUCCESS,
  data,
});

export const transferUsbInvoiceCyclesFail = error => ({
  type: TRANSFER_USB_INVOICE_CYCLES_FAIL,
  error,
});
export const resetTransferUsbInvoiceCycles = error => ({
  type: RESET_TRANSFER_USB_INVOICE_CYCLES,
});

// Tạo bảng kê
export const createReportInvoice = (data, typeReport) => ({
  type: CREATE_REPORT_INVOICE,
  data,
  typeReport,
});

export const createReportInvoiceSuccess = () => ({
  type: CREATE_REPORT_INVOICE_SUCCESS,
});

export const createReportInvoiceFail = error => ({
  type: CREATE_REPORT_INVOICE_FAIL,
  error,
});
export const resetCreateReportInvoice = () => ({
  type: RESET_CREATE_REPORT_INVOICE,
});
// Tiến trình tạo report
// isStartByViewDetail: trường hợp cần xem tiến trình khi click detail thì:true
export const getReportInvoiceProgress = (id, isStartByViewDetail = false) => ({
  type: GET_REPORT_INVOICE_PROGRESS,
  id,
  isStartByViewDetail,
});

export const getReportInvoiceProgressSuccess = data => ({
  type: GET_REPORT_INVOICE_PROGRESS_SUCCESS,
  data,
});

export const getReportInvoiceProgressFail = error => ({
  type: GET_REPORT_INVOICE_PROGRESS_FAIL,
  error,
});
export const resetGetReportInvoiceProgress = () => ({
  type: RESET_GET_REPORT_INVOICE_PROGRESS,
});
// Danh sách bảng kê hóa đơn
export const getReportInvoiceList = (params, typeReport) => ({
  type: REPORT_INVOICE_LIST,
  params,
  typeReport,
});

export const getReportInvoiceListSuccess = (listData, totalCount) => ({
  type: REPORT_INVOICE_LIST_SUCCESS,
  listData,
  totalCount,
});

export const getReportInvoiceListFail = error => ({
  type: REPORT_INVOICE_LIST_FAIL,
  error,
});

export const resetReportInvoiceList = error => ({
  type: REPORT_INVOICE_LIST_RESET,
});

// DOWNLOAD_REPORT_INVOICE
export const downloadReportInvoice = (
  resource_id,
  fileDownloadName,
  responseType
) => ({
  type: DOWNLOAD_REPORT_INVOICE,
  resource_id,
  fileDownloadName,
  responseType,
});

export const downloadReportInvoiceSuccess = (
  fileDownloadResponse,
  fileDownload,
  fileDownloadName
) => ({
  type: DOWNLOAD_REPORT_INVOICE_SUCCESS,
  fileDownloadResponse,
  fileDownload,
  fileDownloadName,
});

export const downloadReportInvoiceFail = error => ({
  type: DOWNLOAD_REPORT_INVOICE_FAIL,
  error,
});
export const resetDownloadReportInvoice = error => ({
  type: RESET_DOWNLOAD_REPORT_INVOICE,
});

export const setColumnVisibleReportInvoiceList = (field, value) => ({
  type: SET_COLUMN_VISIBLE_REPORT_INVOICE_LIST,
  field,
  value,
});

// executeReport
export const executeReport = id => ({
  type: EXECUTE_REPORT,
  id,
});

export const executeReportSuccess = data => ({
  type: EXECUTE_REPORT_SUCCESS,
  data,
});

export const executeReportFail = error => ({
  type: EXECUTE_REPORT_FAIL,
  error,
});

export const resetExecuteReport = error => ({
  type: RESET_EXECUTE_REPORT,
});
